export enum SearchOperatorOptions {
  and = 'AND',
  or = 'OR',
}
